import { css } from 'glamor'

export default {
  mainScreen: css({
    height: '100%',
  }),
  header: css({
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '2px solid #aaa',
    marginBottom: '15px',
    flexDirection: "column",

    '@media (min-width: 650px)': {
      flexDirection: "row",
    },
  }),
  level: css({
    margin: '15px 0',
  }),
  scores: css({
    display: 'flex',
  }),
  score: css({
    display: 'flex',
    alignItems: 'center',
  }),
  mistake: css({
    marginLeft: '15px',
  }),
  scoreTitle: css({
    color: '#999',
    fontSize: '16px',
    marginRight: '5px',
  }),
  scoreValue: css({

  }),



  text:css({
    minHeight: '525px',
    marginBottom: '15px',
    paddingBottom: '15px',
    borderBottom: '2px solid #aaa',

    '@media (min-width: 1025px)': {
      height: 'calc(100% - 170px)',
    },
  }),
  textTitle: css({
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '10px',
  }),
  words: css({
    lineHeight: '1.5',
    fontSize: '17px',

    '@media (min-width: 1025px)': {
      lineHeight: '1.3',
    },
  }),
  delimiter: css({
    margin: '5px 0',
  }),
  word: css({
    cursor: 'pointer',

    ':hover': {
      color: '#9e9e9e',
    }
  }),
  selectedWord: css({
    color: 'blue',
  }),
  findingError: css({
    color: 'green',
  }),
  missError: css({
    color: 'blue',
  }),
  extraError: css({
    color: 'red',
  }),


  footer: css({
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '15px',
    flexDirection: "column",

    '@media (min-width: 700px)': {
      flexDirection: "row",
      padding: '0',
    },
  }),
  buttons: css({
    display: 'flex',

    '&>div:first-child': {
      marginRight: '15px',
    },
  }),

  share: css({
    width: '50px',
    marginRight: '15px',
    cursor: 'pointer',
  }),
  sharedBlock: css({
    marginTop: '15px',

    '@media (min-width: 700px)': {
      marginTop: '0px',
    },
  }),
  sharingTitle: css({
    marginBottom: '5px',
  }),
}



// WEBPACK FOOTER //
// ./src/components/MainScreen/styles.js